import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

export function BarLineChartIcon(props: SVGProps): JSX.Element {
  return <SpriteIcon spriteId="bar-line-chart" {...props} />;
}
